import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import StarRateIcon from '@material-ui/icons/StarRate';
import Button from '@material-ui/core/Button';

const styles = (theme) => ({
    button: {
        background: '#f58634',
        color: 'white',
        borderRadius: '20px',
        padding: '5px 30px',
        textTransform: 'capitalize',
        '&:hover': {
            background: '#f58634'
        }
    }
});

const ButtonComponent = ({ classes, disabled, label, onClick = () => { }, className, styles = {} }) => {
    return (<Button
        size="large"
        color="secondary"
        disabled={disabled}
        className={`${classes.button} ${className}`}
        style={styles}
        onClick={onClick}>
        {label}
    </Button>);
}
export default withStyles(styles)(ButtonComponent);
